import React from 'react'
import styles from './archived-skeleton.styles'
import injectSheet from 'react-jss'
import Bone from 'pobble-components/dist/bone'
import { Table, TableRow, HeadCell } from 'pobble-components/dist/table'
import ArchivedSkeletonEntry from './archived-skeleton-entry/archived-skeleton-entry'

const ArchivedSkeleton = ({ classes }) => (
  <div className={classes.container}>
    <Table className={classes.table}>
      <thead>
        <TableRow>
          <HeadCell className={classes.receivedCell}>
            <Bone className={classes.received} />
          </HeadCell>
          <HeadCell className={classes.receivedCell}>
            <Bone className={classes.received} />
          </HeadCell>
          <HeadCell className={classes.titleCell}>
            <Bone className={classes.title} />
          </HeadCell>
          <HeadCell className={classes.conclusionCell}>
            <Bone className={classes.conclusion} />
          </HeadCell>
        </TableRow>
      </thead>
      <tbody>
        <ArchivedSkeletonEntry titleWidth={200} />
        <ArchivedSkeletonEntry titleWidth={160} />
        <ArchivedSkeletonEntry titleWidth={190} />
        <ArchivedSkeletonEntry titleWidth={170} />
      </tbody>
    </Table>
  </div>
)

export default injectSheet(styles)(ArchivedSkeleton)
